import { render } from "./ModelPriceRangeTyres.vue?vue&type=template&id=0512a746"
import script from "./ModelPriceRangeTyres.vue?vue&type=script&lang=js"
export * from "./ModelPriceRangeTyres.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__